
export const FETCH_USERS = 'fetchUsers'
export const FETCH_ROLES = 'fetchRoles'
export const FETCH_EQUIPMENTS = 'fetchEquipments'
export const FETCH_QUIZ_DETAILS =   'fetchQuizDetails'
export const FETCH_INDIVIDUAL_USER = 'fetchIndividualUser'
export const FETCH_INDIVIDUAL_EQUIPMENT =  'fetchIndividualEquipment'
export const FETCH_INDIVIDUAL_GROUP = 'fetchIndividualGroup'
export const FETCH_INDIVIDUAL_PAGE  =   'fetchIndividualPage'
export const FETCH_USER_DOCUMENTS  =   'fetchUserDocuments'
export const FETCH_INVOICES = 'fetchInvoices'
export const FETCH_GROUPS = 'fetchGroups'
export const FETCH_QUIZ_DATA = 'fetchQuizData'
export const FETCH_LANGUAGES    =   'fetchLanguages'
export const FETCH_PAGES = 'fetchPages'
export const CONTACT_QUERY   =   'contactQuery'
export const AUTO_RENEWAL_OFF = 'autoRenewalOff'
export const FETCH_STRIPE_SECRET_KEY = 'fetchStripeSecretKey'
export const SET_STRIPE_CARD = 'setStripeCard'
export const UPLOAD_USERS_CSV = 'uploadUsersCSV'
export const FORGOT_PASSWORD = 'forgotPassword'
export const FETCH_NAVIGATION_BAR_STATUS = 'fetchNavigationBarStatus'
export const UPDATE_USER_STATUS = 'updateUserStatus'
export const CHECK_TOKEN = 'checkToken'
export const UPDATE_PASSWORD = 'updatePassword'
export const ADD_USER = 'addUser'
export const ADD_GROUP = 'addGroup'
export const ADD_EQUIPMENT = 'addEquipment'
export const UPDATE_EQUIPMENT = 'updateEquipment'
export const LOGIN = 'login'
export const LOGOUT = 'logout'
export const CHECK_AUTH = 'checkAuth'
export const DOWNLOAD_DOCUMENT  =   'downloadDocument'
export const SAVE_USER_SLIDE_ID = 'saveUserSlideID'
export const UPDATE_USER = 'updateUser'
export const DELETE_USER = 'deleteUser'
export const UPDATE_GROUP = 'updateGroup'
export const DELETE_GROUP = 'deleteGroup'
export const DELETE_EQUIPMENT = 'deleteEquipment'
export const DELETE_CARD = 'deleteCard'
export const FETCH_STRIPE_ALL_CARDS ='fetchStripeCards'
export const RESET_STATE    =   'resetState'
export const PAGES_RESET_STATE = "resetPagesState"
export const USERS_RESET_STATE  = 'resetUsersState'
export const STRIPE_RESET_STATE = "resetStripeState"
export const LANGUAGES_RESET_STATE  =   'resetLanguagesState'
export const EQUIPMENTS_RESET_STATE  =   'resetEquipmentsState'
export const GROUPS_RESET_STATE  =   'resetGroupsState'
export const ROLES_RESET_STATE  =   'resetRolesState'
export const GLOBALS_RESET_STATE   =   'resetGlobalsState'
export const FETCH_VOUCHERS = 'fetchVouchers'
export const FETCH_COURSES = 'fetchCourses'
export const FETCH_MODULES = 'fetchModules'
export const FETCH_INDIVIDUAL_MODULE = 'fetchIndividualModule'
export const COURSE_SUBSCRIBE = 'subscribeCourse'
export const FETCH_MODULE_PLAYER = 'fetchModulePlayer'
export const FETCH_GENERAL_DOCUMENTS    =   'fetchGeneralDocuments'
export const FETCH_PERSONAL_DOCUMENTS    =   'fetchPersonalDocuments'
export const DOWNLOAD_GENERAL_DOCUMENT  =   'downloadGeneralDocument'
export const DOWNLOAD_PERSONAL_DOCUMENT  =   'downloadPersonalDocument'
export const UPDATE_USER_DOCUMENT  =   'updateUserDocument'
export const DOWNLOAD_USER_DOCUMENT  =   'downloadUserDocument'
export const FETCH_USER_REGISTRATION_STATUS  =   'fetchUserRegistrationStatus'
export const USER_REGISTRATION  =   'userRegistration'
export const SAVE_USER_REGISTRATION_STATUS  =   'saveUserRegistrationStatus'
export const SAVE_UPDATE_INBOX_SETTINGS     =   'saveUpdateInboxSettings'
export const FETCH_INBOX_SETTINGS   =   'fetchInboxSettings'
export const CLEAR_INBOX_SETTINGS   =   'clearInboxSettings'
export const FETCH_DOCUMENT   =   'fetchDocument'
export const FETCH_LEARNING_SESSION_DATA  =   'fetchLearningSessionData'
export const FETCH_GROUP_USERS  =   'fetchGroupUsers'
export const FETCH_ADMIN_USERS  =   'fetchAdminUsers'
export const FETCH_COMPANY_SETTINGS  =   'fetchCompanySettings'
export const UPDATE_COMPANY_SETTINGS  =   'updateCompanySettings'
export const FETCH_DASHBOARD_DATA   =   'fetchDashboardData'
export const FETCH_DASHBOARD_DOCUMENTS   =   'fetchDashboardDocuments'
export const FETCH_TIME_DATA   =   'fetchTimeData'
export const FETCH_DASHBOARD_QUIZ_DATA   =   'fetchQuizData'
export const FETCH_DASHBOARD_STATS_DATA   =   'fetchDashboardStatsData'
export const FETCH_DASHBOARD_COURSE_QUIZ_DATA = 'fetchdashboardcoursequizdata'
export const FETCH_DASHBOARD_MODULE_QUIZ_DATA = 'fetchdashboardmodulequizdata'
export const FETCH_REMINDER_EMAIL = 'fetchReminderEmail'
export const FETCH_INDIVIDUAL_REMINDER_EMAIL = 'fetchIndividualReminderEmail'
export const DELETE_REMINDER_EMAIL ='deleteReminderEmail'
export const ADD_REMINDER_EMAIL ='addReminderEmail'
export const UPDATE_REMINDER_EMAIL ='updateReminderEmail'
export const FETCH_VIDEO_DATA = 'fetchVideoData'
export const VIDEO_RESET_STATE = 'resetVideoState'
export const FETCH_EQUIPMENT_GROUP_DATA = 'fetchEquipmentGroupData'
export const FETCH_EQUIPMENT_GROUP_INDIVIDUAL_DATA = 'fetchEquipmentGroupIndividualData'
export const ADD_EQUIPMENT_GROUP_DATA = 'addEquipmentGroupData'
export const UPDATE_EQUIPMENT_GROUP_DATA = 'updateEquipmentGroupData'
export const DELETE_EQUIPMENT_GROUP_DATA = 'deleteEquipmentGroupData'
export const FETCH_EQUIPMENT_TEMPLATE_DATA = 'fetchEquipmentTemplateData'
export const FETCH_EQUIPMENT_TEMPLATE_INDIVIDUAL_DATA = 'fetchEquipmentTemplateIndividualData'
export const ADD_EQUIPMENT_TEMPLATE_DATA = 'addEquipmentTemplateData'
export const UPDATE_EQUIPMENT_TEMPLATE_DATA = 'updateEquipmentTemplateData'
export const DELETE_EQUIPMENT_TEMPLATE_DATA = 'deleteEquipmentTemplateData'
export const DOWNLOAD_EQUIPMENT_TEMPLATE_DOCUMENT = 'downloadEquipmentTemplateDocument'
export const FETCH_INDIVIDUAL_PERSONAL_DOCUMENT = 'fetchIndividualPersonalDocument'
export const DELETE_PERSONAL_DOCUMENT = 'deletePersonalDocument'
export const UPDATE_PERSONAL_DOCUMENT = 'updatePersonalDocumentData'
export const ADD_PERSONAL_DOCUMENT = 'addPersonalDocument'
export const FETCH_TEST_GROUP = 'fetchTestGroup'
export const FETCH_INDIVIDUAL_TEST_GROUP = 'fetchIndividiualTestGroup'
export const ADD_TEST_GROUP = 'addTestGroup'
export const UPDATE_TEST_GROUP = 'updateTestGroup'
export const DELETE_TEST_GROUP = 'deleteTestGroup'
export const FETCH_TEST_CASE_TEMPLATE_DATA = 'fetchTestCaseTemplateData'
export const DOWNLOAD_TEST_CASE_TEMPLATE = 'downloadTestCaseTemplateData'
export const FETCH_TEST_CASE_TEMPLATE_INDIVIDUAL_DATA = 'fetchTestCaseTemplateIndividualData'
export const ADD_TEST_CASE_TEMPLATE_DATA = 'addTestCaseTemplateData'
export const UPDATE_TEST_CASE_TEMPLATE_DATA = 'updateTestCaseTemplateData'
export const DELETE_TEST_CASE_TEMPLATE_DATA = 'deleteTestCaseTemplateData'
export const FETCH_CREATE_DOCUMENT = 'fetchCreateDocuments'
export const FETCH_EQUIPMENT_LABEL = 'fetchEquipmentLabel'
export const ADD_EQUIPMENT_LABEL_DATA = 'addEquipmentLabelData'
export const FETCH_TEST_CASE = 'fetchTestCase'
export const FETCH_INDIVIDUAL_TEST_CASE = 'fetchIndividualTestCase'
export const ADD_TEST_CASE = 'addTestCase'
export const UPDATE_TEST_CASE = 'updateTestCase'
export const EDIT_TEST_CASE = 'editTestCase'
export const DELETE_TEST_CASE = 'deleteTestCase'
export const FETCH_USER_CERTIFICATES = 'fetchUserCertificates'
export const FETCH_INDIVIDUAL_CERTIFICATE = 'fetchIndividualCertificates'
export const FETCH_DRAFT_COURSES = 'fetchDraftCourses'
export const BUY_VOUCHERS = 'buyVouchers'
export const LIST_COUPONS = 'listCoupons'
export const SEND_COUPONS = 'sendCoupons'
export const REVOKE_COUPON = 'revokeCoupon'
export const VALIDATE_COUPON = 'validateCoupon'
export const FETCH_TUTOR_PRODUCTS = 'fetchTutorProducts'
export const TUTOR_PRODUCT_SUBSCRIBE = 'subscribeTutorProduct'
export const FETCH_TUTOR_VOUCHERS = 'fetchTutorVouchers'
export const LIST_TUTOR_COUPONS = 'listTutorCoupons'
export const BUY_TUTOR_VOUCHERS = 'buyTutorVouchers'
export const SEND_TUTOR_COUPONS = 'sendTutorCoupons'
export const REVOKE_TUTOR_COUPON = 'revokeTutorCoupons'
export const VALIDATE_TUTOR_COUPON = 'validateTutorCoupon'
export const MICROSOFTLOGIN = 'microsoftLogin'
export const MICROSOFTCALLBACK = 'microsoftCallback'
export const FETCH_QUESTION = 'fetchQuestion'
export const FETCH_INDIVIDUAL_QUESTION = 'fetchIndividualQuestion'
export const ADD_QUESTION = 'addQuestion'
export const UPDATE_QUESTION = 'updateQuestion'
export const DELETE_QUESTION = 'deleteQuestion'
export const FETCH_QUESTION_TOPIC = 'fetchQuestionTopic'
export const ADD_QUESTION_TOPIC_DATA = 'addQuestionTopicData'
export const FETCH_ANSWERS = 'fetchAnswers'
export const FETCH_INDIVIDUAL_ANSWER = 'fetchIndividualAnswer'
export const ADD_ANSWER = 'addAnswer'
export const UPDATE_ANSWER = 'updateAnswer'
export const DELETE_ANSWER = 'deleteAnswer'
export const FETCH_QUIZ = 'fetchQuiz'
export const FETCH_INDIVIDUAL_QUIZ = 'fetchIndividualQuiz'
export const ADD_QUIZ = 'addQuiz'
export const UPDATE_QUIZ = 'updateQuiz'
export const DELETE_QUIZ = 'deleteQuiz'
export const FETCH_MODULE_QUIZ = 'fetchModuleQuiz'
export const ADD_USER_ANSWERS = 'addUserAnswers'
export const FETCH_DASHBOARD_QUIZ_HISTORY_DATA = 'fetchDashboardQuizHistoryData'
export const UPDATE_CUR_USER_LANG = 'updateCurUserLang'




